<script lang="ts">
  import SharepointFileInput from "../../components/SharepointFileInput.svelte";

  let {
    back,
    inactive,
    createUploadSessionUrl,
    financeAgreementUploadAllowedExtensions,
    required,
    errors
  }: {
    back: () => void;
    inactive: boolean;
    createUploadSessionUrl: string;
    financeAgreementUploadAllowedExtensions: string[];
    required: boolean;
    errors: { [key: string]: string } | null;
  } = $props();

  let fileInput = $state<SharepointFileInput>();

  function handleBack() {
    fileInput?.cancelAll();
    back();
  }
</script>

<div class="h-full">
  <fieldset class="ui-fieldset">
    <legend>Upload your finance agreement</legend>

    <div>
      <p class="ui-alert ui-alert-info pb-4 -mb-2.5 mt-0">Please scan or take photo(s) of your finance agreement, including all pages.</p>
      <SharepointFileInput
        bind:this={fileInput}
        name="finance_agreement_document"
        accept={financeAgreementUploadAllowedExtensions}
        {createUploadSessionUrl}
        multiple={true}
        required={required}
      />
    </div>

    {#if errors?.finance_agreement_document}<div class="ui-error">{errors.finance_agreement_document}</div>{/if}
  </fieldset>
</div>

<div class="floating-footer">
  <button type="button" class="btn btn-ghost" onclick={handleBack}>Back</button>
  <button type="submit" class="btn btn-primary" disabled={inactive}>Done</button>
</div>
